// import Worker from 'worker-loader!../bundleParts/features-web-worker.js';
// import Worker from 'worker-loader?publicPath=/content/Views/visualizers/js/!../bundleParts/features-web-worker.js';
import Worker from '../bundleParts/features.worker.js';

import store from "../store";
import {getCurrentLayout} from "../bvcomponents/appLayout";
import {checkIfLookFeaturesReceived, getFeaturesPageSize} from "../api/look-api";
import JsonApi, {addUrlMode, _getUrlBase} from "../api/jsonApi";
import Config, {IS_LIXIL_SERVERS, IS_LIXIL_UI, IS_OFFLINE_MODE} from "../config";
import {shouldUseWizard} from "../misc/loadVisualizer";
import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import {getAllQuotingToolFeatures, getAllWizardFeatures} from "../misc/offlineFunctions";
import {cacheFeaturesThumbnails} from "../misc/offlineImagesCache";

class FeaturesWorker {

  constructor() {
    this.worker = typeof Worker === 'undefined' ? null : new Worker();
    this.cachedFeatures = {}; // "groupName": {[page]: {requestInProgress: "", fetchUrl: "", dbFeatures: [], markUpResponse}};
    this.listeners = {}; // groupName: [callback1, callback2]
    this.isWizard = false;
    this.isDevMode = Config.isDevMode();
    this.wizardLayout = null;
    this.allOfflinefeaturesReceived = false;
    if (this.worker) {
      this.worker.onerror = (e) => {
        console.error("FeaturesWorker returned an error:", e);
      };
      // this.worker.onmessage = (e) => console.log("FeaturesWorker returned a message:", e.type, e.data);
      this.worker.addEventListener('message', this.handleMessageReturn);
      if (this.isDevMode) {
        console.log("featuresWorker initialized", this);
      }
    } else {
      console.log('Web Workers are not supported in this browser.');
      // Fallback to regular fetch or blocking logic
    }
  }

  // initializeFeaturesWorker = () => { // not used, we have all fetch requests separately
  //   if (!this.worker) {
  //     return
  //   }
  //   this.worker.postMessage({
  //     type: "fwSetConfig",
  //     payload: { baseUrl: document.kvConfig.domain, fabricatorId: document.kvConfig.userId}
  //   });
  //   console.log("featuresWorker initialized", this);
  // }

  handleMessageReturn = (e) => {
    if (!e.data || !e.data.type || !e.data.data) {
      return
    }
    const payload = e.data.data;
    if (e.data.type === "fwRequestGroup") {
      const prevGroup = this.cachedFeatures[payload.groupName] || {};
      this.cachedFeatures = {
        ...this.cachedFeatures,
        [payload.groupName]: {
          ...prevGroup,
          [payload.page]: {
            ...prevGroup[payload.page],
            requestInProgress: true,
            fetchUrl: payload.fetchUrl,
          }
        },
      };
    }
    if (e.data.type === "fwUpdateCache" || e.data.type === "fwGroupError") {
      this.cachedFeatures = {
        ...this.cachedFeatures,
        [payload.groupName]: { // "groupName": {groupName: "", fetchUrl: "", dbFeatures: []};
          [payload.page]: {
            fetchUrl: payload.fetchUrl,
            dbFeatures: payload.dbFeatures,
            markUpResponse: payload.markUpResponse,
          }
        },
      };
      if (this.listeners[payload.groupName]) {
        this.listeners[payload.groupName].forEach(callBack => callBack(this.cachedFeatures[payload.groupName]));
        delete this.listeners[payload.groupName]; // clear after notifying
      }
    }
    if (e.data.type === "fwGroupsAllRequested" && IS_OFFLINE_MODE) {
      this.getAllMissingFeatures()
    }
  }

  addGroupReadyListener(groupName, cb) {
    if (!this.listeners[groupName]) {
      this.listeners[groupName] = [];
    }
    this.listeners[groupName].push(cb);
  }

  waitForGroup(groupName, page = 0, timeoutMs = 16000) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Error(`Timeout waiting for group exceeded ${groupName}`));
      }, timeoutMs);

      this.addGroupReadyListener(groupName, (cachedGroupName) => {
        clearTimeout(timer);
        if (cachedGroupName && cachedGroupName[page] && cachedGroupName[page].dbFeatures) {
          if (this.isDevMode) {
            console.log(cachedGroupName[page].fetchUrl, "caching waitForGroup returned", cachedGroupName[page].dbFeatures);
          }
          resolve(cachedGroupName[page]);
          return;
        }
        reject(new Error(`Callback returned with an error groupName: ${groupName}, page: ${page}, cachedGroupName: ${cachedGroupName}`));
      });
    });
  }

  getFeaturesWorkerCachedFeatures(groupName, page, requestUrl = "") {
    // console.log("workerCache", workerCache);
    const cachedGroup = this.cachedFeatures[groupName];
    if (!cachedGroup) {
      return Promise.resolve(null); // it was never requested, return and make a simple request
    }
    if (!cachedGroup[page]) {
      if (this.isDevMode) {
        console.log("Group is cached but no page requested?", requestUrl, page, cachedGroup);
      }
      return Promise.resolve(null);
    }
    if (requestUrl !== cachedGroup[page].fetchUrl) { // make sure they are the same, otherwise it will be a different request
      if (this.isDevMode) {
        console.log("Group is cached but request URLs are different", requestUrl, cachedGroup[page].fetchUrl);
      }
      return Promise.resolve(null);
    }
    if (cachedGroup[page].dbFeatures) { // yes, they are already there! return them
      if (this.isDevMode) {
        console.log(cachedGroup[page].fetchUrl, "cachedResponse+", {data: cachedGroup[page].dbFeatures});
      }
      return Promise.resolve(this.cachedFeatures[groupName][page]);
    } else if (cachedGroup[page].requestInProgress) {
      return this.waitForGroup(groupName, page, IS_OFFLINE_MODE ? 120000 : 16000) // 2min || 16sec
    }
    return Promise.resolve(null);
  }

  sendPostMessageToReceiveGroups = (toRequestFeatureGroups, layoutType, fabricatorSettings, page = 0) => {
    if (this.isDevMode) {
      console.log("toRequestFeatureGroups", toRequestFeatureGroups);
    }
    if (!toRequestFeatureGroups || !toRequestFeatureGroups.length) { // just in case
      return
    }
    this.worker.postMessage({ type: "fwFetchFeatureGroups", payload: {
        toRequestFeatureGroups,
        layoutType,
        page,
        withMarkUp: fabricatorSettings.useMarkUpFeaturesRequests,
      }
    });
  }

  getFeatureGroupObjectsToReceive = async (featureGroup, fabricatorSettings, layoutType, layout = getCurrentLayout()) => {
    // [{groupName, fetchUrl}]
    let toRequestFeatureGroups = [];
    const baseUrl = _getUrlBase();
    const neededForThisGroup = await checkIfLookFeaturesReceived(featureGroup, false, true);

    neededForThisGroup.forEach(fg => {
      const testGroupName = fg.dbName || fg.partName;
      if (!toRequestFeatureGroups.some(fgObject => fgObject.groupName === testGroupName)) {
        const pageSize = getFeaturesPageSize(fg);
        const groupNameFixed = JsonApi.fixGroupName(testGroupName);

        let fetchGroupUrl = layout.visualizerType === "kvScene" && !IS_LIXIL_SERVERS
          ? `${baseUrl}/api/public/bvdataR/${document.kvConfig.userId}/features/${groupNameFixed}/0/${pageSize}/`
          : `${baseUrl}/api/public/bvdata/${document.kvConfig.userId}/features/${groupNameFixed}/0/${pageSize}/`;

        const oldToolVersions = document.kvConfig.toolVersion <= 4;
        if (fg.nextFeaturesPageToLoadArray || oldToolVersions) {
          fetchGroupUrl += oldToolVersions
            ? layout.getCurrentLayoutAbbreviation() + "/"
            : layoutType + "/";
        }
        fetchGroupUrl += addUrlMode("", layout.visualizerType);
        if (fabricatorSettings.leadCapture) {
          fetchGroupUrl += (fetchGroupUrl.includes("?") ? "&" : "?") + "sortBy=unlocked";
        }
        if (fg.additionalPartPartId && layout.parts["Walls"]
          && layout.parts["Walls"].relatedItems.some(relItem => relItem.partId === fg.partId)) {
          toRequestFeatureGroups.push({
            groupName: testGroupName + " Crop",
            fetchGroupUrl: fetchGroupUrl
              .replace(pageSize + "/", pageSize * 3 + "/")
              .replace(groupNameFixed, groupNameFixed + "%20Crop"),
            baseUrl,
          })
        }
        toRequestFeatureGroups.push({
          groupName: testGroupName,
          fetchGroupUrl,
          baseUrl,
        })
      }
    })
    return toRequestFeatureGroups
  }

  fetchFeaturesWorkerWizardGroups = async (wizardList, layoutType, layout) => {
    if (!this.worker) {
      return
    }
    const fabricatorSettings = store.getState().fabricatorState.settings;
    let toRequestFeatureGroups = []; // {groupName, featureGroup, pageSize}
    for (const wizardItem of wizardList) {
      for (const wizardGroup of wizardItem.wizardGroups) {
        if (!toRequestFeatureGroups.some(fgObject => wizardGroup.groupName === fgObject.groupName)) {
          const featureGroup = layout.getFeatureGroupByGroupName(wizardGroup.groupName);
          if (featureGroup) {
            toRequestFeatureGroups = [
              ...toRequestFeatureGroups,
              ... await this.getFeatureGroupObjectsToReceive(featureGroup, fabricatorSettings, layoutType, layout)
            ]
          }
        }
      }
    }
    // now we have an Array of featureGroups // go ahead and cache them
    this.sendPostMessageToReceiveGroups(toRequestFeatureGroups, layoutType, fabricatorSettings);
  }

  fetchFeaturesQuotingToolGroups = async (featureGroups, layoutType, layout) => {
    if (!this.worker) {
      return
    }
    const fabricatorSettings = store.getState().fabricatorState.settings;
    let toRequestFeatureGroups = []; // {groupName, featureGroup, pageSize}
    for (const featureGroup of featureGroups) {
      toRequestFeatureGroups = [
        ...toRequestFeatureGroups,
        ... await this.getFeatureGroupObjectsToReceive(featureGroup, fabricatorSettings, layoutType, layout)
      ]
    }
    this.sendPostMessageToReceiveGroups(toRequestFeatureGroups, layoutType, fabricatorSettings);
  }

  cacheFeatureGroupsResponses(mainResponse, qtCategories, layout) {
    if (!mainResponse || !mainResponse.defaults) {
      console.log("No caching as we don't have a preset", mainResponse);
      return;
    }
    if (IS_LIXIL_UI) {
      return;
    }
    const loadByTheDefault = mainResponse.defaults.find(preset => preset.loadByTheDefault);
    if (!loadByTheDefault) {
      return;
    }
    this.isWizard = shouldUseWizard(mainResponse, qtCategories);
    this.wizardLayout = layout;
    if (this.isWizard) {
      this.fetchFeaturesWorkerWizardGroups(mainResponse.wizardList, loadByTheDefault.layout_type, layout);
      // } else if (presets && document.kvConfig.visualizerType) {
      //   const loadByTheDefault = responseData.data.defaults.find(preset => preset.loadByTheDefault);
      //   if (loadByTheDefault) {
      //     fetchFeaturesWorkerCountertops(loadByTheDefault.layout_type); // start loading features on th background
      //   }
    } else {
      const featureGroups = [];
      if (Array.isArray(qtCategories) && qtCategories.length) {
        qtCategories.forEach((qtCat) => {
          qtCat.featureGroups.forEach((featureGroup) => {
            if (!featureGroups.some(fg => (fg.dbName || fg.partName) === featureGroup.groupName)) {
              const fGroup = layout.getFeatureGroupByGroupName(featureGroup.groupName);
              if (fGroup) {
                featureGroups.push(fGroup)
              }
            }
          })
        });
      }
      if (loadByTheDefault && featureGroups.length) {
        this.fetchFeaturesQuotingToolGroups(featureGroups, loadByTheDefault.layout_type, layout);
      }
    }
  }

  getAllMissingFeatures = async () => {
    if (this.wizardLayout.initialized) {
      loaderEnable();
    }
    if (this.isWizard) {
      await getAllWizardFeatures(this.wizardLayout);
    } else {
      await getAllQuotingToolFeatures(this.wizardLayout);
    }
    await cacheFeaturesThumbnails(); // use service worker to cache thumbnails after all features received
    this.allOfflinefeaturesReceived = true;
    if (this.wizardLayout.initialized) {
      loaderDisable();
    }
  }

}

const featuresWorker = new FeaturesWorker();
export default featuresWorker
